/**
 * Merge 2 object
 * @param obj1
 * @param obj2
 */
export default function mergeObject(obj1, obj2) {
  return { ...obj2, ...obj1 }
}